module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_isTransformer.js
// module id = 1381
// module chunks = 0